const cubic = value => Math.pow(value, 3)
const easeInOutCubic = value => value < 0.5
  ? cubic(value * 2) / 2
  : 1 - cubic((1 - value) * 2) / 2

export default {
  scrollBy: function (top, container = window) {
    const beginTime = Date.now()
    const beginValue = container.scrollTop
    const rAF = window.requestAnimationFrame || (func => setTimeout(func, 16))
    const frameFunc = () => {
      const progress = (Date.now() - beginTime) / 500
      if (progress < 1) {
        container.scrollTop = beginValue + top * easeInOutCubic(progress)
        rAF(frameFunc)
      } else {
        container.scrollTop = beginValue + top
      }
    }
    rAF(frameFunc)
  }
}
